import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import type { ArgoCDGenerateAnnotationsFields } from "~/analytics/AnalyticSession";
import type { ArgoCDGenerateAnnotationsEvent, ArgoCDGenerateAnnotationsEventDispatcher } from "~/analytics/Analytics";
export function useArgoCDGenerateAnnotationsEventDispatcher(): ArgoCDGenerateAnnotationsEventDispatcher {
    const session = useAnalyticSession();
    return (name: string, event: ArgoCDGenerateAnnotationsEvent) => {
        const fields: ArgoCDGenerateAnnotationsFields = {
            "Source Page": event.sourcePage,
            "Available Applications": event.availableApplications,
            "Available Projects": event.availableProjects,
            "Available Tenants": event.availableTenants,
            "Available Environments": event.availableEnvironments,
            "Correlation Id": event.correlationId,
        };
        if (event.gatewayName) {
            fields["Gateway Name"] = session.anonymize(event.gatewayName);
        }
        if (event.spaceId) {
            fields["Space Id"] = session.anonymize(event.spaceId);
        }
        if (event.gatewayName && event.spaceId) {
            fields["Unique Identifier"] = session.anonymize(`${event.spaceId}-${event.gatewayName}`);
        }
        session.track(name, fields);
    };
}
